import React from 'react'

import { connect } from 'react-redux'

import Row from "./row";
import AddRow from "./addRow";

import { selectRow } from "../../actions/index";

const Header = ({ header, row, handleRowSelection }) => (
    <div style={{ border: "dashed 1px lightgray", padding: "5px" }}>
        <span style={{ textDecoration: "underline" }}>Header</span>
        {header.map((content, index) => (
            <div key={index}>
                <Row content={content}
                    id={content.id}
                    selected={row.selected === content.id}
                    onSelection={handleRowSelection}
                    parentIndex={index}
                    sectionName="header" />
            </div>
        ))}
        <AddRow list={header} 
            lastRowId={header.length > 0 ? header[header.length - 1].id : 'design_header_0'}
        />
    </div>
);

const mapStateToProps = (state) => {
    return {
        header: state.design.header, row: state.row
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleRowSelection: id => {
            dispatch(selectRow(id))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)